export const PLAYER_PARAM = 'player';
export const LEGACY_PLAYER = 'legacy';

const storageKey = (rundownId: string) => `player:version:${rundownId}`;
const BASE_URL = import.meta.env.VITE_SERVICE_GRAPHICS_OUTPUT_URL;
const LEGACY_BASE_URL = import.meta.env.VITE_SERVICE_GRAPHICS_OUTPUT_LEGACY_URL;

export const hasLegacyPlayer = Boolean(LEGACY_BASE_URL);

export function isLegacyPlayer(rundownId: string | undefined): boolean {
  if (!rundownId) return false;

  return localStorage.getItem(storageKey(rundownId)) === LEGACY_PLAYER;
}

export function setLegacyPlayer(rundownId: string, isLegacy: boolean): void {
  if (isLegacy) {
    localStorage.setItem(storageKey(rundownId), LEGACY_PLAYER);
  } else {
    localStorage.removeItem(storageKey(rundownId));
  }
}

export function playerBaseUrl(isLegacy: boolean): string {
  return isLegacy && LEGACY_BASE_URL ? LEGACY_BASE_URL : BASE_URL;
}

// The API builds its own path and query, so only the origin moves.
export function toPlayerUrl(url: string | undefined, isLegacy: boolean): string | undefined {
  if (!url || !isLegacy || !LEGACY_BASE_URL) return url;

  try {
    const { protocol, host } = new URL(LEGACY_BASE_URL);
    const target = new URL(url);
    target.protocol = protocol;
    target.host = host;

    return target.toString();
  } catch {
    return url;
  }
}
